/**
 * "COMO FICA A PROVA DE CADA ALUNO" na web (28/10/2026) — a cópia da regra do servidor (`backend/src/services/
 * provaDeCadaAluno.ts`: `cartaoDoSimulado`, `cartaoPadrao`, `ROTULO_DO_CARTAO`). Mexeu numa, mexa na outra.
 */
export type Cartao = 'IGUAL' | 'MISTURADA_UMA_VEZ' | 'LETRAS_POR_ALUNO' | 'TUDO_POR_ALUNO';
export const CARTOES: Cartao[] = ['IGUAL', 'MISTURADA_UMA_VEZ', 'LETRAS_POR_ALUNO', 'TUDO_POR_ALUNO'];

/**
 * OS NOMES DOS QUATRO TIPOS DE PROVA — UM nome por tipo, em todo lugar (28/10/2026, decisão do pesquisador). O COMPLETO:
 * o passo 4 da criação, a revisão do passo 5, o "Este simulado:" da janela "Gerar PDF", a prévia, a janela "Mudar".
 * O CURTO (`CURTO_DO_CARTAO`): o cartão do simulado na lista e onde faltar espaço. O servidor tem a mesma tabela
 * (`backend/src/services/provaDeCadaAluno.ts`). Texto novo que nomeie o tipo usa estas constantes — não escreve outro nome.
 */
export const ROTULO_DO_CARTAO: Record<Cartao, string> = {
  IGUAL: 'Igual para todos, como montada',
  MISTURADA_UMA_VEZ: 'Igual para todos, misturada uma vez',
  LETRAS_POR_ALUNO: 'Questões na mesma posição, letras de cada aluno',
  TUDO_POR_ALUNO: 'Tudo embaralhado para cada aluno',
};

/** O nome CURTO: o cartão do simulado na lista e onde faltar espaço. */
export const CURTO_DO_CARTAO: Record<Cartao, string> = {
  IGUAL: 'igual para todos',
  MISTURADA_UMA_VEZ: 'misturada uma vez',
  LETRAS_POR_ALUNO: 'letras por aluno',
  TUDO_POR_ALUNO: 'embaralhada por aluno',
};

export type SimuladoComCartao = { provaDeCadaAluno?: string | null; shuffleQuestions?: boolean | null; shuffleOptions?: boolean | null };

export function cartaoDoSimulado(s: SimuladoComCartao): Cartao {
  if (s.provaDeCadaAluno && (CARTOES as string[]).includes(s.provaDeCadaAluno)) return s.provaDeCadaAluno as Cartao;
  if (s.shuffleQuestions) return 'TUDO_POR_ALUNO';
  if (s.shuffleOptions) return 'LETRAS_POR_ALUNO';
  return 'IGUAL';
}

/** O papel do cartão: o caderno da turma (1 e 2) ou um caderno por aluno (3 e 4). */
export const papelDoCartao = (c: Cartao): 'TURMA' | 'POR_ALUNO' => (c === 'IGUAL' || c === 'MISTURADA_UMA_VEZ' ? 'TURMA' : 'POR_ALUNO');

/** O padrão pela aplicação: só pelo portal → tudo embaralhado; com papel → a mesma prova, misturada uma vez. */
export const cartaoPadrao = (aplicacao: string | null | undefined): Cartao => (aplicacao === 'SO_ONLINE' ? 'TUDO_POR_ALUNO' : 'MISTURADA_UMA_VEZ');

/** Nos cartões 3 e 4 com papel: o custo, dito antes de escolher. */
export const CUSTO_DO_PAPEL_POR_ALUNO = 'Não dá para tirar cópia: uma turma de 35 = 35 cadernos, e cada aluno faz com o próprio caderno.';
